export class EnvService {

  // The values that are defined here are the default values that can
  // be overridden by env.js

  public eventGenieAppURL = '';
  public production = false;
  public apiUrl = '';

  constructor() {
  }

}
